<template>
  <div>
    <div
      v-if="value"
      class="modal-backdrop fade show"
      @click="cancelar"
    ></div>

    <div
      v-if="value"
      class="modal fade show"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="tituloId"
      style="display: block"
      @keydown.esc="cancelar"
      @click.self="cancelar"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="tituloId">
              <slot name="header"></slot>
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Fechar"
              :disabled="loading"
              @click="cancelar"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-secondary"
              :disabled="loading"
              @click="cancelar"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="loading"
              @click="confirmar"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm mr-1"
                role="status"
              >
                <span class="sr-only">Confirmando</span>
              </span>
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalConfirmacao",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tituloId: "modal-confirmacao-titulo-" + this._uid
    };
  },
  watch: {
    value(aberto) {
      if (aberto) {
        document.body.classList.add("modal-open");
        this.$nextTick(() => {
          const dialog = this.$el.querySelector('[role="dialog"]');
          if (dialog) {
            dialog.focus();
          }
        });
      } else {
        document.body.classList.remove("modal-open");
      }
    }
  },
  beforeDestroy() {
    document.body.classList.remove("modal-open");
  },
  methods: {
    cancelar() {
      if (this.loading) {
        return;
      }
      this.$emit("cancelar");
      this.$emit("input", false);
    },
    confirmar() {
      if (this.loading) {
        return;
      }
      this.$emit("confirmar");
    }
  }
};
</script>

<style scoped>
.modal-footer {
  justify-content: space-between;
}
</style>
